import { Listbox } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { DollarCircle } from 'iconoir-react'
import { useEffect, useState } from 'react'
import { MONEY_ICON_FILL } from 'app/lib/iconColors'

export default function AttributionTableFilter({
  defaultFilter,
  onFilterChange,
}: {
  defaultFilter:
    | `Source`
    | `Medium`
    | `Source / Medium`
    | `Campaign`
    | `Ad Campaign`
    | `Ad Platform`
    | `Channel`
    | `Reported Attribution`
  onFilterChange: (
    filter:
      | `Source`
      | `Medium`
      | `Source / Medium`
      | `Campaign`
      | `Ad Campaign`
      | `Ad Platform`
      | `Channel`
      | `Reported Attribution`,
  ) => void
}) {
  const [filter, setFilter] = useState<
    | `Source`
    | `Medium`
    | `Source / Medium`
    | `Campaign`
    | `Ad Campaign`
    | `Ad Platform`
    | `Channel`
    | `Reported Attribution`
  >(defaultFilter)
  const options = [
    `Source`,
    `Medium`,
    `Source / Medium`,
    `Campaign`,
    `Ad Campaign`,
    `Ad Platform`,
    `Channel`,
    `Reported Attribution`,
  ]

  useEffect(() => {
    onFilterChange(filter)
  }, [filter])
  return (
    <Listbox as="div" value={filter} onChange={setFilter} className="relative">
      {({ open }) => (
        <>
          <Listbox.Button className="text-default btn btn-sm btn-tertiary flex items-center gap-2 px-4 py-2">
            {[`Ad Campaign`, `Ad Platform`].includes(filter) && (
              <DollarCircle height={16} width={16} className="mr-1 text-on-color" style={{ fill: MONEY_ICON_FILL }} />
            )}
            <p className="text-ui-xs">{filter}</p>
            <ChevronDownIcon
              className={classNames(`h-4 w-4 fill-current stroke-current text-default`, {
                [`rotate-180 transform`]: open,
              })}
            />
          </Listbox.Button>
          <Listbox.Options
            modal={false}
            className="absolute right-0 top-9 z-50 mt-1 h-max w-max overflow-auto rounded-lg border border-default bg-surface-raised shadow-elevation-4 ring-0 focus:outline-none"
          >
            {options.map((option) => (
              <Listbox.Option
                key={option}
                value={option}
                className="flex cursor-pointer items-center p-4 text-body-sm capitalize text-default hover:bg-(--menu-hover)"
              >
                {[`Ad Campaign`, `Ad Platform`].includes(option) && (
                  <DollarCircle
                    height={16}
                    width={16}
                    className="mr-1 text-on-color"
                    style={{ fill: MONEY_ICON_FILL }}
                  />
                )}
                {option}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </>
      )}
    </Listbox>
  )
}
